const highlightedLayoutMap = {
    ODIRATING: {
        name: 'ODIRATING',
        type: 'ODIRATING',
        tab: {
            icon: '',
            text: '',
            style: 'od-recommended-itinerary-tab',
            boxStyle: 'highlighted',
        },
        pill: {
            icon: '',
            text: 'recommendedOdiratingPillLabel',
            style: 'odf-pills-positive od-resultcard-odirating-pill',
        },
    },
    CHEAPEST: {
        name: 'CHEAPEST',
        type: 'RECOMMENDED',
        tab: {
            icon: 'odf-icon-cash',
            text: 'cheapestRecommended',
            style: 'od-recommended-itinerary-tab',
            boxStyle: 'od-recommendation',
        },
        pill: {
            icon: '',
            text: 'cheapestRecommended',
            style: 'od-resultcard-odirating-pill od-resultcard-odirating-pill-color',
        },
    },
    FAST: {
        name: 'FAST',
        type: 'RECOMMENDED',
        tab: {
            icon: 'odf-icon-time',
            text: 'fastRecommended',
            style: 'od-recommended-itinerary-tab',
            boxStyle: 'od-recommendation',
        },
        pill: {
            icon: '',
            text: 'fastRecommended',
            style: 'od-resultcard-odirating-pill od-resultcard-odirating-pill-color',
        },
    },
    BAGGAGE: {
        name: 'BAGGAGE',
        type: 'RECOMMENDED',
        tab: {
            icon: 'odf-icon-baggage',
            text: 'baggageRecommended',
            style: 'od-recommended-itinerary-tab',
            boxStyle: 'od-recommendation',
        },
        pill: {
            icon: '',
            text: 'baggageRecommended',
            style: 'od-resultcard-odirating-pill od-resultcard-odirating-pill-color',
        },
    },
    NONE: {
        name: 'NONE',
        type: 'NONE',
        tab: {
            icon: '',
            text: '',
            style: '',
            boxStyle: '',
        },
        pill: {
            icon: '',
            text: '',
            style: '',
        },
    },
};
module.exports = {
    highlightedLayoutMap,
};
